var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmr01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 55.17,
    viewBox: "0 0 60 55.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oaoac5qowa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15444",
    style: {
      fill: "none"
    },
    d: "M0 0h60v55.17H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 731",
    style: {
      clipPath: "url(#oaoac5qowa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 733"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59581",
    d: "M41.574 52.822a24.319 24.319 0 1 1 1.2-41.093",
    transform: "translate(-1.216 -3.894)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59582",
    d: "M18.894 31.636 29.8 42.544l28.164-28.162",
    transform: "translate(-4.724 -5.595)",
    style: {
      stroke: "#4cbbb8",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 16",
    transform: "translate(49.362 29.958)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0v13.98"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 17",
    transform: "translate(42.373 36.948)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M13.98 0H0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmr01);
export default __webpack_public_path__ + "static/media/amr_01.2d200366ff01370aff0845a746911f76.svg";
export { ForwardRef as ReactComponent };